import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// theme: 'auto' | 'light' | 'dark'
const useThemeStore = create(
  persist(
    (set) => ({
      theme: 'auto',
      setTheme: (theme) => {
        document.documentElement.setAttribute('data-theme', theme)
        set({ theme })
      }
    }),
    { name: 'organizer-theme' }
  )
)

export default useThemeStore
